;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Select = require("./Select.vue");

var _Select2 = _interopRequireDefault(_Select);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    value: Object,
    onChange: Function,
    fields: Object
  },
  data: function data() {
    return {
      model: this.value
    };
  },

  watch: {
    value: function value() {
      this.model = this.value;
    },

    model: {
      deep: true,
      handler: function handler() {
        if (!this.model.versatile) {
          this.model.widthBack = "";
          this.model.profileBack = "";
        }

        this.$emit("input", this.model);
      }
    }
  },
  computed: {
    versatile: function versatile() {
      return this.model.versatile;
    }
  },
  components: {
    Select: _Select2.default
  },
  methods: {
    toggleVersatile: function toggleVersatile() {
      this.model.versatile = !this.model.versatile;
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sizes-select"},[_c('div',{staticClass:"grid is-columns is-filter"},[_c('div',{staticClass:"col-8 col-s-12"},[_c('div',{staticClass:"sizes-select__content"},[_c('div',{staticClass:"sizes-select__fields"},[_c('div',{staticClass:"grid is-columns is-filter"},[_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"sizes-select__field"},[_c('Select',{attrs:{"name":"width","options":_vm.fields.width.options,"placeholder":_vm.fields.width.placeholder,"on-change":_vm.onChange},model:{value:(_vm.model.width),callback:function ($$v) {_vm.$set(_vm.model, "width", $$v)},expression:"model.width"}})],1)]),_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"sizes-select__field"},[_c('Select',{attrs:{"name":"profile","options":_vm.fields.profile.options,"placeholder":_vm.fields.profile.placeholder,"on-change":_vm.onChange},model:{value:(_vm.model.profile),callback:function ($$v) {_vm.$set(_vm.model, "profile", $$v)},expression:"model.profile"}})],1)]),(_vm.versatile)?_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"sizes-select__field"},[_c('Select',{attrs:{"name":"widthBack","options":_vm.fields.widthBack.options,"placeholder":_vm.fields.widthBack.placeholder,"on-change":_vm.onChange},model:{value:(_vm.model.widthBack),callback:function ($$v) {_vm.$set(_vm.model, "widthBack", $$v)},expression:"model.widthBack"}})],1)]):_vm._e(),(_vm.versatile)?_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"sizes-select__field"},[_c('Select',{attrs:{"name":"profileBack","options":_vm.fields.profileBack.options,"placeholder":_vm.fields.profileBack.placeholder,"on-change":_vm.onChange},model:{value:(_vm.model.profileBack),callback:function ($$v) {_vm.$set(_vm.model, "profileBack", $$v)},expression:"model.profileBack"}})],1)]):_vm._e()])]),(_vm.versatile)?_c('div',{staticClass:"sizes-select__car"}):_vm._e(),(!_vm.versatile)?_c('button',{staticClass:"sizes-select__toggle",attrs:{"type":"button"},on:{"click":_vm.toggleVersatile}},[_vm._v("Разноширокие шины")]):_vm._e()])]),_c('div',{staticClass:"col-4 col-s-12"},[_c('div',{staticClass:"sizes-select__field"},[_c('Select',{attrs:{"name":"diameter","options":_vm.fields.diameter.options,"placeholder":_vm.fields.diameter.placeholder,"on-change":_vm.onChange},model:{value:(_vm.model.diameter),callback:function ($$v) {_vm.$set(_vm.model, "diameter", $$v)},expression:"model.diameter"}})],1),(_vm.versatile)?_c('button',{staticClass:"sizes-select__toggle is-active",attrs:{"type":"button"},on:{"click":_vm.toggleVersatile}},[_vm._v("Одинаковые шины")]):_vm._e()])])])}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-33ec19f2", __vue__options__)
  } else {
    hotAPI.reload("data-v-33ec19f2", __vue__options__)
  }
})()}